<script>
import store from '@state/store'
import { debounce } from 'debounce'
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import AdminTable from '@components/admin-table.vue'
import { COMPANIES_TABLE_FIELDS } from '@adminCompanies/constant'

export default {
  components: {
    Layout,
    AdminTable,
  },
  data() {
    return {
      tableFields: COMPANIES_TABLE_FIELDS,
    }
  },
  computed: {
    ...authComputed,
    page() {
      return this.$store.state.adminCompanies.page
    },
    perPage() {
      return this.$store.state.adminCompanies.perPage
    },
    lists() {
      return this.$store.state.adminCompanies.lists || []
    },
    total() {
      return this.$store.state.adminCompanies.total
    },
    loaded() {
      return this.$store.state.adminCompanies.loaded
    },
  },
  methods: {
    setPage(params) {
      store.dispatch('adminCompanies/setPage', params)
    },
    setFilterParams: debounce(async function setFilterParams(name) {
      await store.dispatch('adminCompanies/setFilterParams', name)
    }, 500),
    setSortParams(params) {
      store.dispatch('adminCompanies/setSortParams', params)
    },
    goAddItem(item) {
      this.$router.push({ name: 'adminCompaniesAdd' })
    },
    goEditItem(item) {
      this.$router.push({
        name: 'adminCompaniesEdit',
        params: { companyId: item.id, item },
      })
    },
    deleteCompany(id) {
      store.dispatch('adminCompanies/deleteItem', id)
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white pt-4 px-8 pb-12 mb-16">
      <AdminTable
        table-type="COMPANIES"
        :table-fields="tableFields"
        :total-num="total"
        :list-data="lists"
        :data-loaded="loaded"
        :cur-page="page"
        :per-page="perPage"
        @table-add-item="goAddItem"
        @table-set-sort-params="setSortParams"
        @table-set-filter-params="setFilterParams"
        @table-go-edit-item="goEditItem"
        @table-delete-item="deleteCompany"
        @table-set-page="setPage"
      />
    </div>
  </Layout>
</template>
